/**
 * Supply Chain — component suppliers, third-party software,
 * supply-chain touchpoints. Pulls from `formatted.supply_chain`.
 * Always renders.
 */
import React from 'react';
import { SectionCard, SubSection, ObjectListField, type SectionProps } from './parts';

const PATH = ['supply_chain'];

const yesNo = (v) => (v === true ? 'true' : v === false ? 'false' : '');
const joinList = (v) => (Array.isArray(v) ? v.join(', ') : v);

export default function SupplyChain({ data, isEditing, onChange }: SectionProps) {
  const sc = data ?? {};
  const suppliers = sc.component_suppliers?.suppliers ?? [];
  const thirdParty = sc.third_party_software?.components ?? [];
  const touchpoints = sc.supply_chain_touchpoints?.touchpoints ?? [];

  const supplierColumns = [
    { key: 'supplier_name', label: 'Supplier' },
    { key: 'component_id', label: 'Component' },
    { key: 'tier_level', label: 'Tier' },
    { key: 'supply_chain_security', label: 'Security Controls', render: joinList },
    { key: 'trusted_supplier', label: 'Trusted', render: yesNo },
  ];
  const softwareColumns = [
    { key: 'software_name', label: 'Component' },
    { key: 'version', label: 'Version' },
    { key: 'license', label: 'License' },
    { key: 'purpose', label: 'Purpose' },
    { key: 'open_source', label: 'OSS', render: yesNo },
    { key: 'known_vulnerabilities', label: 'Known Vulns', render: joinList },
    { key: 'update_mechanism', label: 'Update Mechanism' },
    { key: 'security_assessment', label: 'Security Assessment' },
  ];
  const touchpointColumns = [
    { key: 'lifecycle_phase', label: 'Lifecycle Phase' },
    { key: 'external_party', label: 'External Party' },
    { key: 'interaction_type', label: 'Interaction' },
    { key: 'security_controls', label: 'Security Controls', render: joinList },
    { key: 'risk_level', label: 'Risk Level' },
  ];

  return (
    <SectionCard title="Supply Chain" id="supply_chain">
      <SubSection title="Component suppliers" count={suppliers.length}>
        <ObjectListField columns={supplierColumns} rows={suppliers} isEditing={isEditing} onChange={onChange} path={[...PATH, 'component_suppliers', 'suppliers']} />
      </SubSection>

      <SubSection title="Third-party software" count={thirdParty.length}>
        <ObjectListField columns={softwareColumns} rows={thirdParty} isEditing={isEditing} onChange={onChange} path={[...PATH, 'third_party_software', 'components']} />
      </SubSection>

      <SubSection title="Supply chain touchpoints" count={touchpoints.length}>
        <ObjectListField columns={touchpointColumns} rows={touchpoints} isEditing={isEditing} onChange={onChange} path={[...PATH, 'supply_chain_touchpoints', 'touchpoints']} />
      </SubSection>
    </SectionCard>
  );
}
